import { createClient } from '@supabase/supabase-js';

console.log('supabase.ts: Initializing Supabase client...');

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('supabase.ts: Supabase URL:', supabaseUrl);
console.log('supabase.ts: Supabase Anon Key exists:', !!supabaseAnonKey);

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('supabase.ts: Missing Supabase configuration!');
  console.error('supabase.ts: REACT_APP_SUPABASE_URL:', supabaseUrl);
  console.error('supabase.ts: REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'exists' : 'missing');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');

console.log('supabase.ts: Supabase client created successfully');